define([
    'text!questionSets',
    'text!portal/config/faq.json',
    'text!portal/config/facebook.json',
    'text!portal/config/campaignUrlParams.json',
    'text!portal/config/infoTextWhitelist.json',
    'text!portal/views/root.html',
    'portal/constants',
    'angularRouter',
    'edge/platform/tracking/module',
    'edge/platform/tracking/adapters/module',
    'eTrackerAdapterPath'
], (QuestionSets, faqConfig, facebookConfig, campaignUrlParamsConfig, infoTextWhitelistConfig, rootTemplate, loadEnvironmentSpecificConstants) => {

    const eventAdapterModules = ['customer.edge.platform.tracking.adapters', 'edge.platform.tracking.adapters'];

    /**
     * Module used to define application level configuration parameters that should be
     * passed to capability modules
     */
    const configModule = angular.module('portal.config', ['ui.router', 'edge.platform.tracking', ...eventAdapterModules]);

    loadEnvironmentSpecificConstants();

    configModule
        .config(['adapters.googleAnalyticsProvider', 'CredentialsProvider', 'configBasler', (googleAnalyticsProvider, credentialsProvider, configBasler) => {
            googleAnalyticsProvider.enablePlugin('ecommerce');

            if (configBasler.tracking && configBasler.tracking.googleAnalytics) {
                googleAnalyticsProvider.configure({'trackingID': configBasler.tracking.googleAnalytics.trackingID})
            }
        }])

        // Diego Cabero: Configuring eTrackerAdapter
        .config(['adapters.eTrackerProvider', 'configBasler', (eTrackerAdapterProvider, configBasler) => {

            if (configBasler.tracking && configBasler.tracking.eTracker) {

                eTrackerAdapterProvider
                    .configure({'trackingID': configBasler.tracking.eTracker.trackingID})
                    .configure({'url': configBasler.tracking.eTracker.url})
            }
        }])

        .config(['adapters.segmentIOProvider', 'configBasler', (segmentIOProvider, configBasler) => {

            if (configBasler.tracking && configBasler.tracking.segmentIO) {
                segmentIOProvider.configure({'writeKey': configBasler.tracking.segmentIO.writeKey});
            }
        }])

        .config(['EventHubProvider', EventAdapterProvider => {
            EventAdapterProvider
                .register({
                    serviceName: 'console',
                    handler: 'log'
                })
                .register({
                    serviceName: 'googleAnalytics',
                    handler: 'trackPageView',
                    category: 'tracking',
                    eventName: 'pageView'
                })
                .register({
                    serviceName: 'segmentIO',
                    handler: 'trackJourney',
                    category: 'tracking',
                    eventName: 'journey'
                })
                .register({
                    serviceName: 'googleAnalytics',
                    handler: 'trackPurchase',
                    category: 'journey',
                    eventName: 'purchase'
                })
                .register({
                    serviceName: 'googleAnalytics',
                    handler: 'trackServerCall',
                    category: 'tracking',
                    eventName: 'serverCall'
                })
                .register({
                    serviceName: 'localstorage',
                    handler: 'onEvent'
                })
                .register({
                    serviceName: 'segmentIO',
                    handler: 'trackPageView',
                    category: 'tracking',
                    eventName: 'pageView'
                })
                .register({
                    serviceName: 'segmentIO',
                    handler: 'trackEvent',
                    category: 'journey',
                    eventName: 'purchase'
                })
                .register({
                    serviceName: 'segmentIO',
                    handler: 'trackServerCall',
                    category: 'tracking',
                    eventName: 'serverCall'
                })
                .register({
                    serviceName: 'segmentIO',
                    handler: 'trackEvent',
                    category: 'journey',
                    eventName: 'submission'
                });
        }])

        /**
         * Defines the prefix url where the set of states for a sub module should
         * plug into the portal application
         */
        .constant('state_plugin_config', {
            quote_bind: 'root',
            home: 'home',
            quickQuote: 'quickQuote'
        })

        .constant('QUESTION_SETS_CONFIG', JSON.parse(QuestionSets))
        .constant('FAQ_CONFIG', JSON.parse(faqConfig))
        .constant('FACEBOOK_CONFIG', JSON.parse(facebookConfig))
        .constant('CAMPAIGN_PARAMS_CONFIG', JSON.parse(campaignUrlParamsConfig))
        .constant('INFOTEXT_WHITELIST', JSON.parse(infoTextWhitelistConfig))

        .config(['$stateProvider', '$urlRouterProvider', ($stateProvider, $urlRouterProvider)=> {
            const states = [
                {
                    name: 'root',
                    url: '',
                    template: rootTemplate,
                    abstract: true
                }
            ];

            for (let i = 0; i < states.length; i++) {
                $stateProvider.state(states[i]);
            }

            //$urlRouterProvider.when('initial', 'initial');
            $urlRouterProvider.otherwise('home');
        }]);

    // environment specific constants are added to the existing config module
    // (see generated "constants.js" and Gruntfile.js)
    // see https://confluence.baloisenet.com/confluence/x/iwMXP
    // loadEnvironmentSpecificConstants();

    return configModule;
});



// WEBPACK FOOTER //
// ./app/js/portal/config.js